import Header from './components/Header';
import Hero from './components/Hero';
import Comments from './components/Comments';
import Updates from './components/Updates';
import Cards from './components/Cards';
import Media from './components/Media';
import Ranking from './components/Ranking';
import Faq from './components/Faq';
import About from './components/About';
import Index from './components/Index';
import Carousel from './components/Carousel';
import Topics from './components/Topics';
import AppSection from './components/AppSection';
import Contact from './components/Contact';
import Features from './components/Features';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Comments />
        <Updates />
        <Cards />
        <Media />
        <Ranking />
        <Faq />
        <About />
        <Index />
        <Carousel />
        <Topics />
        <AppSection />
        <Contact />
        <Features />
      </main>
      <Footer />
    </>
  );
}